import React from "react";
import PropTypes from "prop-types";

const mimeTypes = {
  flv: "video/x-flv",
  mp4: "video/mp4",
  m3u8: "application/x-mpegURL",
  ts: "video/MP2T",
  "3gp": "video/3gpp",
  mov: "video/quicktime",
  avi: "video/x-msvideo",
  wmv: "video/x-ms-wmv",
};

function getFileExtension(path) {
  return path.slice((Math.max(0, path.lastIndexOf(".")) || Infinity) + 1);
}

function GalleryVideoSource({ src, ...props }) {
  return (
    <source src={src} type={mimeTypes[getFileExtension(src)]} {...props} />
  );
}

GalleryVideoSource.propTypes = {
  src: PropTypes.string.isRequired,
};

GalleryVideoSource.displayName = "ModalGallery.Video.Source";

export default GalleryVideoSource;
